<template>
  <header class="header pb-header-background">
    <div class="header__wrap content-xl">
      <div class="header__options">
        <a
          v-if="!isLogged && !isLoading"
          rel="noopener noreferrer"
          class="pb-header-color"
          @click="login">
          Login
        </a>
        <div
          v-if="isLogged"
          class="header__info">
          <p
            v-if="userSession"
            class="pb-header-color">
            {{ userSession.username }}
          </p>
          <a
            href=""
            rel="noopener noreferrer"
            @click="logout"
            class="pb-header-color">
            Logout
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Header',
  computed: {
    ...mapState(['isLogged', 'userSession', 'isLoading'])
  },
  methods: {
    async login () {
      await this.$store.dispatch('login')
      window.location.href = this.$store.state.loginUrl.url
    },
    logout () {
      localStorage.clear()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../scss/variables';

.header {
  background: $primary-color;
  color: #fff;
  padding: 10px 0;

  &__wrap {
    display: flex;
    justify-content: flex-end;
  }

  &__title {
    font-weight: 600;
  }

  &__options {
    display: flex;

    a {
      color: #fff;
      cursor: pointer;
    }
  }

  &__info {
    display: flex;
    align-items: center;

    p {
      margin: 0 20px;
    }
  }
}
</style>
